/**
 * Normalizes admin list API responses: either { data, pagination } or a legacy raw array.
 */
export function normalizeAdminListResponse(res) {
  const body = res?.data;
  if (body && Array.isArray(body.data) && body.pagination) {
    return { data: body.data, pagination: body.pagination };
  }
  if (Array.isArray(body)) {
    return {
      data: body,
      pagination: {
        hasMore: false,
        total: body.length,
        page: 1,
        limit: body.length,
        totalPages: 1
      }
    };
  }
  return {
    data: [],
    pagination: { hasMore: false, total: 0, page: 1, limit: 30, totalPages: 1 }
  };
}
